/**
 * @flow
 */
'use strict';

export const treatmentRecommendationCodes = [
[
  {"code":"Change Rx\n"},
  {"code":"First Rx\n"},
  {"code":"First progressive\n"},
  {"code":"Cl trial\n"},
  {"code":"Cl teaching\n"},
],
[
  {"code":"See again tomorrow"},
  {"code":"See again in 3 days"},
  {"code":"See again in 5 days"},
  {"code":"See again in 1 week"},
  {"code":"See again in 1 month"},
  {"code":"See again"},
  {"code":"Annual control"},
],
[
  {"code":" for regular eye exam\n"},
  {"code":" for visual field\n"},
  {"code":" for fundus photos\n"},
  {"code":" for OCT\n"},
  {"code":" for diabetic eye exam\n"},
  {"code":" for cataract check\n"},
  {"code":" for glaucoma suspect\n"},
  {"code":" for BIO\n"},
  {"code":" for cyclo.\n"},
],
[
  {"code":"Refer to ophthalmology"},
  {"code":"Medication as directed"},
  {"code":"Co-MGMT"}
]]
